module.exports = __webpack_public_path__ + "4c5b695cf5398839b420a8530a4a711c.svg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/Tutors/images/img_tutor_step02.svg
// module id = 1606
// module chunks = 8